export default "__VITE_ASSET__D_ql5Uwe__"